import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-timberwolf border-t border-brand-pearl/10">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
  src="logos/rudralogo.png"
  alt="Rudra Apparel"
  className="h-20 w-auto mx-auto mb-4 object-contain"
/>{/* <div className="w-10 h-10 rounded-sm border-2 border-brand-pearl flex items-center justify-center">
                <span className="text-xl font-heading font-bold text-brand-pearl">R</span>
              </div> */}
              <span className="text-lg font-heading font-semibold text-brand-pearl">
                Rudra Apparel
              </span>
            </div>
            <p className="text-sm text-brand-walnut leading-relaxed">
              Premium bespoke uniform manufacturing and ready-to-wear apparel for institutions and individuals.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-brand-pearl font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/bespoke" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-bespoke">Bespoke Manufacturing</Link></li>
              <li><Link to="/shop" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-shop">Shop</Link></li>
              <li><Link to="/process" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-process">Our Process</Link></li>
              <li><Link to="/work" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-work">Our Work</Link></li>
              <li><Link to="/bulk" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-bulk">Bulk Orders</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-heading text-brand-pearl font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li><Link to="/fabric-guide" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-fabric-guide">Fabric Guide</Link></li>
              <li><Link to="/size-guide" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-size-guide">Size Guide</Link></li>
              <li><Link to="/care-instructions" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-care">Care Instructions</Link></li>
              <li><Link to="/faq" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-faq">FAQ</Link></li>
              <li><Link to="/contact" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading text-brand-pearl font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Mail className="w-4 h-4 mt-0.5 text-brand-walnut" />
                <a href="mailto:info@rudraapparel.com" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors">
                  info@rudraapparel.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Phone className="w-4 h-4 mt-0.5 text-brand-walnut" />
                <a href="tel:+919619977421" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors">
                  +91 9619977421
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-0.5 text-brand-walnut" />
                <span className="text-sm text-brand-walnut">
                  Mumbai, Maharashtra, India
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-brand-pearl/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-brand-walnut">
              © {currentYear} Rudra Apparel. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link to="/terms" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-terms">Terms</Link>
              <Link to="/privacy" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-privacy">Privacy</Link>
              <Link to="/refund" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-refund">Refund</Link>
              <Link to="/shipping" className="text-sm text-brand-walnut hover:text-brand-pearl transition-colors" data-testid="footer-link-shipping">Shipping</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};